export default {
  button: {
    backgroundColor: '#004E27',
    borderColor: '#004E27',
  },
};
